import { proxy } from "valtio";

const baseEventCounts = {
  NEW_ENGAGEMENT_CLICKED: 0, // User clicked on +Engagement above the Engagement List
  ENGAGEMENT_CREATED: 0, // New Engagement modal sends when an Engagement is created.
  ENGAGEMENT_DELETED: 0,
  ENGAGEMENT_NAME_UPDATED: 0,
  LAUNCH_SELECTED: 0,
  VIEW_ENGAGEMENT_CLICKED: 0,
  VIEW_ENGAGEMENT_FROM_DATA_VIEW: 0,
  ENGAGEMENT_STATUS_UPDATED: 0
} as const

type EngagementEventKeys = keyof typeof baseEventCounts;

export const engagementEvents = proxy({
    ...baseEventCounts,
    send_event(this: any, key: EngagementEventKeys) {
        this[key] += 1;
    },
});
